
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.847 11.412"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_29880","data-name":"Path 29880","d":"M1.717 4.303a1.447 1.447 0 01.217-.016h9.978a1.447 1.447 0 01.217.016m-10.412 0a1.42 1.42 0 00-1.188 1.6l.541 3.79a1.42 1.42 0 001.4 1.219h8.9a1.42 1.42 0 001.405-1.219l.541-3.787a1.42 1.42 0 00-1.188-1.6m-10.412 0V1.92A1.42 1.42 0 013.137.5h2.448a.947.947 0 01.669.278l1.339 1.338a.947.947 0 00.669.278h2.448a1.42 1.42 0 011.42 1.42v.49","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1"}})])
          )
        }
      }
    